import { DialogTitle } from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from 'components/ui/dialog';
import { Input } from 'components/ui/input';
import { LoaderIcon } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';

interface SaveImageModalProps {
  resultsImageUrl: string;
  handleSave?: (title: string, video_url: string) => Promise<void>;
  isLoading?: boolean;
}

export default function SaveImageModal({
  resultsImageUrl,
  handleSave,
  isLoading = false,
}: SaveImageModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState('');
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  const isSaving = isLoading || isLocalLoading;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!handleSave || !fileName.trim()) {
      toast.error('Please enter a file name');
      return;
    }

    try {
      setIsLocalLoading(true);
      await handleSave(fileName.trim(), resultsImageUrl);
      setFileName('');
      setIsOpen(false);
    } catch (error) {
      console.error('Save failed:', error);
    } finally {
      setIsLocalLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="customPrimary" className="w-full lg:w-[300px] ">
          Save
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-md text-text-primary">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-primary">
            Save as
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-2">
            <label htmlFor="fileName">Gif Title</label>
            <Input
              id="fileName"
              name="fileName"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
              placeholder="Enter gif title"
              disabled={isSaving}
            />
          </div>

          <DialogFooter className="mt-4">
            <Button
              type="button"
              variant="customSecondary"
              className="bg-secondary"
              onClick={() => setIsOpen(false)}
              disabled={isSaving}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="customSecondary"
              className="bg-secondary w-[200px]"
              disabled={isSaving || !fileName.trim()}
            >
              {isSaving ? (
                <>
                  <LoaderIcon className="mr-2 h-4 w-4 animate-spin" />
                  Saving...
                </>
              ) : (
                'Save & Continue'
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
